import { I as IconWrapper, _ as _objectSpread2 } from '../../dist/Icon-e9280b89.esm.js';
import 'react';
import { jsx } from 'react/jsx-runtime';
import 'styled-components';
import '@lendi-ui/color';
function SvgInfoTwo(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsx("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      children: /*#__PURE__*/jsx("path", {
        fillRule: "evenodd",
        d: "M11 8.6h2.6V6H11v2.6zM11 19h2.6v-7.8H11V19z"
      })
    })
  }));
}
export { SvgInfoTwo as default };